import axios from "../axios-auth";
import orginal_axios from "axios";

export const cashReportService = {
    getCashReportList,
    getRealCashIncomeDetailList,
    getComputerSaleDetailList,
    getCashReportListForPrint,
    getCashReportExcelExport
};

function getCashReportList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds.join();
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/summary-cash-report", { params });
}

function getRealCashIncomeDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds.join();
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/real-cash-income-detail-report", { params });
}

function getComputerSaleDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds.join();
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/computer-sale-detail-report", { params });
}

function getCashReportListForPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds.join();
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/cash-report-print", { params });
}

function getCashReportExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds.join();
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/cash-report-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}